// Small metadata tag for collection cards: template, integration, files, etc.
// `accent` marks integration tags so they read apart from plain metadata.
export default function MetaChip({ icon: Icon, children, title, accent = false, className = '' }) {
  return (
    <span
      title={title}
      className={`inline-flex min-w-0 max-w-full items-center gap-1 rounded-md px-1.5 py-0.5 text-[11px] font-medium ring-1 ring-inset transition-colors duration-200 ${
        accent
          ? 'bg-navy-50 text-navy-700 ring-navy-200/70 dark:bg-navy-500/10 dark:text-navy-200 dark:ring-navy-400/20'
          : 'bg-gray-50 text-gray-600 ring-gray-200 dark:bg-gray-800/60 dark:text-gray-300 dark:ring-gray-700/70'
      } ${className}`}
    >
      {Icon && <Icon className="h-3 w-3 flex-shrink-0 opacity-70" aria-hidden="true" />}
      <span className="truncate">{children}</span>
    </span>
  )
}
